export default __webpack_public_path__ + "static/media/background-slice.a2513a04.png";